import type { Dispatch, SetStateAction } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";

import { Tab, type TabOption } from "../";
import styles from "./FolderTabs.module.scss";

export const FolderTabs = <Key extends string>({
  active,
  options,
  setActive,
  tabClassName,
}: {
  active: Key;
  setActive: Dispatch<SetStateAction<Key>>;
  options: TabOption<Key>[];
  tabClassName?: string;
}) => {
  const [block] = useModuleBEM(styles, "FolderTabs");

  return (
    <div className={block}>
      {options.map((option) => (
        <Tab
          className={tabClassName}
          key={option.value}
          label={option.label}
          active={active === option.value}
          onClick={() => setActive(option.value)}
        />
      ))}
    </div>
  );
};
